import { render, staticRenderFns } from "./OcOtro.vue?vue&type=template&id=19972e68"
import script from "./OcOtro.vue?vue&type=script&lang=js"
export * from "./OcOtro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports